import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { IoClose } from "react-icons/io5";
import { Formik, Form, FieldArray } from "formik";
import { MODULE_URLS } from "../constants/module-urls";
import { useLocation } from "react-router-dom";
import { axiosService } from "../../services/axios.service";

function DefaultAnswerModal({ isOpen, onClose, onSubmit }) {
  const location = useLocation();
  const [selectedOption, setSelectedOption] = useState("");
  const [options, setOptions] = useState([]);
  useEffect(() => {
    axiosService.get(`${MODULE_URLS.GET_ALL_DEFAULT_RESPONSE}`).then((response) => {
      if (response.status === 200) {
        const responseData = response.data.data;
        setOptions(responseData);
      }
    });
  }, [location.pathname]);
  useEffect(() => {
    setSelectedOption("");
  }, [isOpen]);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const handleFormSubmit = () => {
    onSubmit(selectedOption);
    onClose();
  };
  const customModalStyles = {
    content: {
      height: "50vh",
      margin: "auto",
      padding: "10px 20px 0px 20px",
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      shouldReturnFocusAfterClose={false}
      style={{
        ...customModalStyles,
        content: {
          ...customModalStyles.content,
          width: "80%",
        },
      }}
    >
      <div className="modal-container">
        <div className="modal-header">
          <span className="modal-head-Text">Default Responses</span>
          <IoClose
            color="#000000"
            size={"23px"}
            style={{ cursor: "pointer" }}
            onClick={() => {
              onClose();
            }}
          />
        </div>
        <div className="modal-body">
          <Formik initialValues={{ options: [] }} enableReinitialize={true}>
            {({ values }) => (
              <Form>
                <FieldArray
                  name="options"
                  render={(arrayHelpers) => (
                    <div style={{ marginTop: "7px", padding: "10px" }}>
                      {options?.map((option, index) => (
                        <span
                          key={index}
                          className="option"
                          style={{
                            fontFamily: "sans-serif",
                            backgroundColor:
                              selectedOption === option?.responseText
                                ? "#f2f2f2"
                                : "transparent",
                          }}
                          onClick={() =>
                            handleOptionClick(option?.responseText)
                          }
                        >
                          <span className="circle">{index + 1}</span>{" "}
                          {option?.responseText}
                        </span>
                      ))}
                    </div>
                  )}
                />
              </Form>
            )}
          </Formik>
        </div>
        <div className="submit-button-container">
          <button
            type="submit"
            className="list-add-bttn"
            onClick={() => handleFormSubmit()}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DefaultAnswerModal;
